<style lang="scss">
.panel-motos {
  margin-left: 8px;
}
</style>
<template>
  <div class="panel panel-default panel-motos">
    <div class="panel-heading">
      <h3 class="panel-title">Motos asociadas al servicio ({{ this.detalles.length }})</h3>
    </div>
    <div class="panel-body">
      <div>
        <button class="btn btn-default btn-sm no-print" style="margin-bottom: 5px"
                @click.prevent="agregarMoto()" v-if="!servicio.readonly">
          <i class="fa fa-plus"></i> Agregar
        </button>
        <div class="pull-right">
          <div class="inline-flex mb-6">
            <input type="text" class="form-control" placeholder="Filtrar por modelo" v-model="filtroMoto"/>
            <button type="button" class="btn btn-sm btn-outline btn-primary ml-2" @click="limpiarFiltro">
              Limpiar
            </button>
          </div>
        </div>
      </div>
      <div class="table-scrollable" v-show="detalles.length > 0">
        <table class="table table-bordered table-condensed table-striped vmiddle">
          <thead>
          <tr>
            <th style="width: 3%"></th>
            <th style="width: 15%">Modelo</th>
            <th style="width: 15%">Duración
              <small class="text-muted">(hrs.)</small>
            </th>
            <th style="width: 15%">Repuestos <small class="text-muted">(sin IVA)</small></th>
            <th style="width: 15%">Precio Final <small class="text-muted">(IVA incl.)</small></th>
            <th>Incluye</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(detalle, index) in filtrarMotos" v-bind:key="index">
            <td class="text-center">
              <button class="btn btn-sm default no-print" style="margin: 0"
                      @click.prevent="eliminarDetalle(detalle)"
                      v-if="!servicio.readonly">
                <i class="fa fa-times"></i>
              </button>
            </td>
            <td class="form-group">
              <select v-model="detalle.moto_id" aria-label="Moto" class="form-control required"
                      v-bind:name="getElementName('moto_id', index)"
                      @change="obtenerTotalRepuesto(detalle)">
                <option v-for="moto in motos" v-bind:value="moto.id"
                        :disabled="servicio.readonly && detalle.moto_id !== moto.id">
                  {{ moto.modelo }}
                </option>

              </select>
            </td>
            <td class="form-group">
              <div class="input-group">
                <input type="number" class="form-control text-right required"
                       @change.prevent="calcularPrecioFinal(detalle)"
                       :readonly="servicio.readonly"
                       v-model="detalle.duracion"
                       v-bind:name="getElementName('duracion', index)"/>
                <span class="input-group-addon">hrs</span>
              </div>
            </td>
            <td class="form-group">
              <div class="flex">
                <div class="input-group">
                  <span class="input-group-addon">$</span>
                  <currency-input v-bind:name="getElementName('total_repuestos', index)"
                                  class="form-control text-right" readonly
                                  title="Monto" placeholder="Repuestos"
                                  v-model="detalle.total_repuestos"
                                  @focus="verificarCero(detalle)"></currency-input>
                </div>
                <button type="button" class="btn blue-hoki btn-sm"
                        v-if="servicio.id && detalle.moto_id && motoGuardada(detalle.moto_id)"
                        @click.prevent="mostrarRepuestos(detalle.moto_id)">
                  <i class="fal fa-toolbox"></i> Ver
                </button>
                <!-- El backend rechaza los repuestos de una moto que todavía no está guardada en el servicio -->
                <span v-else-if="servicio.id && detalle.moto_id" class="flex js-tooltip-ver" data-placement="top"
                      title="Guarda el servicio para configurar los repuestos de esta moto.">
                  <button type="button" class="btn blue-hoki btn-sm" disabled style="pointer-events: none">
                    <i class="fal fa-toolbox"></i> Ver
                  </button>
                </span>
              </div>
            </td>
            <td class="form-group">
              <div class="input-group">
                <span class="input-group-addon">$</span>
                <currency-input v-bind:name="getElementName('valor', index)"
                                class="form-control text-right required"
                                title="Monto" placeholder="Valor"
                                :readonly="detalle.total_repuestos > 0"
                                v-model="detalle.valor"
                                @focus="verificarCero(detalle)"></currency-input>
              </div>
            </td>
            <td class="form-group">
              <textarea class="form-control w-full" rows="10"
                        v-model="detalle.incluye"
                        :readonly="servicio.readonly"
                        v-bind:name="getElementName('incluye', index)"></textarea>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'servicio': {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      id: null,
      motos: [],
      // Motos que ya están guardadas en el servicio: sólo ellas pueden configurar repuestos
      idMotosGuardadas: [],
      detalles: [],
      valor_hora: 0,
      filtroMoto: ''
    }
  },

  methods: {
    /**
     * Retorna un nuevo objeto detalle
     *
     * @returns {Object}
     */
    nuevaMoto() {
      return {
        moto_id: '',
        duracion: '',
        valor: '',
        incluye: '',
        total_repuestos: '',
      }
    },

    /**
     * Agrega un nuevo detalle
     *
     * @param {Object} [moto]
     */
    agregarMoto(moto) {
      moto = this.nuevaMoto();
      this.detalles.push(moto);
    },

    /**
     * Obtiene las motos activas (id y modelo) para el selector.
     * BIT-1692: no usa api/motos, que trae los servicios de todos los distribuidores.
     */
    obtenerMotos() {
      axios.get('api/agendamiento/motos').then(response => {
        this.motos = response.data;
      });
    },

    obtenerDetalles() {
      if (this.servicio.id) {
        axios.get('api/agendamiento/servicios/' + this.servicio.id, {}).then(response => {
          this.detalles = response.data.detalle;
          this.idMotosGuardadas = this.detalles.map(detalle => detalle.moto_id);
        });
      }
    },

    eliminarDetalle(detalle) {
      // La tabla recorre la lista filtrada: su índice no sirve para la lista completa
      this.detalles.splice(this.detalles.indexOf(detalle), 1);
    },

    motoGuardada(motoId) {
      return this.idMotosGuardadas.includes(motoId);
    },

    mostrarRepuestos(motoId) {
      const moto = this.motos.find(m => m.id === motoId);

      Bus.$emit("mostrar-repuestos", moto);
    },

    /**
     * Obtiene el nombre normalizado del elemento a partir de un nombre e índice
     *
     * @param {String} nombre Nombre del elemento
     * @param {int} index Índice del elemento
     * */
    getElementName(nombre, index) {
      return `detalles[${index}][${nombre}]`;
    },

    /**
     * Verifica si el actual input tiene un 0
     * */
    verificarCero(detalle) {
      if (detalle.valor === 0) detalle.valor = '';
    },

    roundUp(number, precision) {
      precision = precision || 0;
      const multiplier = Math.pow(10, precision);

      return Math.ceil(number * multiplier) / multiplier;
    },

    calcularPrecioFinal(detalle) {
      if (detalle) {
        const totalRepuesto = Number(('' + detalle.total_repuestos).replace(/\D/g, ''));

        if (totalRepuesto > 0) {
          let precioFinal = (detalle.duracion * this.valor_hora + totalRepuesto) * 1.19;
          // Redondea a la centena superior más cercana, menos 10 pesos (ver ServicioService::obtenerPrecioFinalServicio())
          detalle.valor = this.roundUp(precioFinal, -3) - 10;
        }

        return;
      }

      this.detalles.forEach(item => {
        const totalRepuesto = Number(('' + item.total_repuestos).replace(/\D/g, ''));
        if (totalRepuesto > 0) {
          let precioFinal = (item.duracion * this.valor_hora + totalRepuesto) * 1.19;
          // Redondea a la centena superior más cercana, menos 10 pesos (ver ServicioService::obtenerPrecioFinalServicio())
          item.valor = this.roundUp(precioFinal, -3) - 10;
        }
      });
    },

    obtenerTotalRepuesto(detalle) {
      if (this.servicio.es_maestro) {
        axios.get('api/agendamiento/repuestos/total/' + detalle.moto_id + '/' + this.servicio.id).then(response => {
          detalle.total_repuestos = response.data.total;

          this.calcularPrecioFinal(detalle);
        });
      }
    },

    limpiarFiltro() {
      this.filtroMoto = '';
    }
  },

  computed: {
    filtrarMotos() {
      return this.detalles.filter(detalle => {
        const modelo = detalle.moto_modelo || '';
        return modelo.toLowerCase().includes(this.filtroMoto.toLowerCase());
      });
    }
  },

  mounted() {
    this.valor_hora = this.servicio.valor_hora;
    // Obtiene los modelos de motos
    this.obtenerMotos();
    this.obtenerDetalles();

    // Tooltip Bootstrap delegado: el aviso del "Ver" deshabilitado aparece al instante y alcanza
    // también a las filas que se agregan después de cargar la página
    $(this.$el).tooltip({
      selector: '.js-tooltip-ver',
      container: 'body',
      trigger: 'hover',
    });

    Bus.$on("valor-hora", valor => {
      this.valor_hora = valor;
      this.calcularPrecioFinal();
    });

    Bus.$on("limpiar-filtro", () => {
      this.limpiarFiltro();
    });

    Bus.$on("total-repuestos", valores => {
      const index = this.detalles.findIndex(d => d.moto_id === valores.moto_id);
      this.detalles[index].total_repuestos = valores.total_repuestos;
      this.calcularPrecioFinal(this.detalles[index]);
    });
  },
}
</script>



// WEBPACK FOOTER //
// resources/vue/components/agendamiento/MotosServicio.vue